import { Card, ProcessingSuspense } from 'octiv-components';
import React from 'react';

export default ({ title, children, isLoading, ...props }) => (
  <Card mb={6} title={title} {...props}>
    {isLoading || !children ? <ProcessingSuspense /> : children}
  </Card>
);
